import React, { useState, useEffect } from "react";
import Input from "../../../../../../../components/Input/Input";
import Select from "../../../../../../../components/Select/Select";
import Button from "../../../../../../../components/Button/Button";
import Toggle from "../../../../../../../components/Toggle/Toggle";
import "./CheckSupport.css";
import { useLocation, useNavigate } from "react-router-dom";
import Modal from "../../../../../../../components/Modal/Modal";
//services
import { supportService } from "../../../../../../../services/Support";
//utils
import { formatDate } from "../../../../../../../utils/utils";

const CheckSupport = () => {
  const { support } = useLocation().state;
  const navigate = useNavigate();
  const isApprovalTicket =
    support?.reason?.toLowerCase().includes("approval of subcategory") ||
    support?.reason?.toLowerCase().includes("approval of category");
  const [selectedStatus, setSelectedStatus] = useState("");
  const [selectedResult, setSelectedResult] = useState("");
  const [description, setDescription] = useState("");
  const [applyRefund, setApplyRefund] = useState(false);
  const [applyFine, setApplyFine] = useState(false);
  const [movementRefund, setMovementRefund] = useState(null);
  const [movementRefundId, setMovementRefundId] = useState(null);
  const [movementApplyId, setMovementApplyId] = useState(null);
  const [movement, setMovement] = useState(null);
  const [percentage, setPercentage] = useState("");
  const [percentageRefund, setPercentageRefund] = useState("");
  const [reason, setReason] = useState("");
  const [reasonRefund, setReasonRefund] = useState("");
  const [isCancelled, setIsCancelled] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [title, setTitle] = useState({ text: "", highlight: "" });
  const [message, setMessage] = useState("");
  const [error, setError] = useState(false);
  const statusOptions = [
    { value: "completed", label: "Completed" },
    { value: "cancelled", label: "Cancelled" },
  ];
  const resultOptions = [
    { value: "accepted", label: "Accepted" },
    { value: "rejected", label: "Rejected" },
  ];
  const movementOptions = [
    { value: "movement", label: "Movement" },
    { value: "free_quantity", label: "Free quantity" },
  ];
  const [isMovementRefund, setIsMovementRefund] = useState(true);
  const [isMovement, setIsMovement] = useState(true);
  const [movements, setMovements] = useState([]);
  const [errors, setErrors] = useState({});

  useEffect(() => {
    console.log("support", support);
    fetchMovements();
  }, []);

  const fetchMovements = async () => {
    try {
      const response = await supportService.getMovements(support.user_id);
      if (
        response.status === "success" &&
        response.data &&
        response.data.data.length > 0
      ) {
        const movements = response.data.data;
        const movementsOptions = movements.map((movement) => ({
          value: movement.id,
          label:
            movement.transaction_type +
            ": " +
            movement.description +
            " - " +
            formatDate(movement.created_at),
          price: movement.token_pack?.price,
        }));
        setMovements(movementsOptions);
      }
    } catch (error) {
      console.error("Error fetching movements:", error);
    }
  };

  const validateForm = () => {
    const newErrors = {};
    let hasErrors = false;

    if (isApprovalTicket) {
      if (!selectedResult) {
        newErrors.result = "Please select a result";
        hasErrors = true;
      }
      if (!description.trim()) {
        newErrors.description = "Please enter a description";
        hasErrors = true;
      }
      setErrors(newErrors);
      return !hasErrors;
    }
    // Validar status
    if (!selectedStatus) {
      newErrors.status = "Please select a status";
      hasErrors = true;
    }

    // Validar descripción
    if (!description.trim()) {
      newErrors.description = "Please enter a description";
      hasErrors = true;
    }

    // Validar campos de refund si está activo
    if (applyRefund) {
      if (!movementRefund) {
        newErrors.movementRefund = "Please select a movement type";
        hasErrors = true;
      }

      // Validar ID de movimiento si es tipo 'movement'
      if (isMovementRefund && !movementRefundId) {
        newErrors.movementRefundId = "Please select a movement";
        hasErrors = true;
      }

      // Validar porcentaje
      if (!percentageRefund) {
        newErrors.percentageRefund = "Please enter a percentage";
        hasErrors = true;
      } else if (!/^\d+$/.test(percentageRefund)) {
        newErrors.percentageRefund = "Percentage must be a number";
        hasErrors = true;
      } else if (
        parseInt(percentageRefund) <= 0 ||
        parseInt(percentageRefund) > 100
      ) {
        newErrors.percentageRefund = "Percentage must be between 1 and 100";
        hasErrors = true;
      }

      // Validar razón
      if (!reasonRefund.trim()) {
        newErrors.reasonRefund = "Please enter a reason";
        hasErrors = true;
      }
    }

    // Validar campos de fine si está activo
    if (applyFine) {
      if (!movement) {
        newErrors.movement = "Please select a movement type";
        hasErrors = true;
      }

      // Validar ID de movimiento si es tipo 'movement'
      if (isMovement && !movementApplyId) {
        newErrors.movementApplyId = "Please select a movement";
        hasErrors = true;
      }

      // Validar porcentaje
      if (!percentage) {
        newErrors.percentage = "Please enter a percentage";
        hasErrors = true;
      } else if (!/^\d+$/.test(percentage)) {
        newErrors.percentage = "Percentage must be a number";
        hasErrors = true;
      } else if (parseInt(percentage) <= 0 || parseInt(percentage) > 100) {
        newErrors.percentage = "Percentage must be between 1 and 100";
        hasErrors = true;
      }

      // Validar razón
      if (!reason.trim()) {
        newErrors.reason = "Please enter a reason";
        hasErrors = true;
      }
    }

    setErrors(newErrors);
    return !hasErrors;
  };

  const handleSave = async () => {
    try {
      if (!validateForm()) {
        return;
      }

      let data = {};

      if (isApprovalTicket) {
        data = {
          status: "completed",
          result: selectedResult,
          response: description,
        };
      } else {
        data = {
          status: selectedStatus,
          response: description,
        };

        if (applyFine) {
          data = {
            ...data,
            penalty: {
              movement_type: movement,
              movement_id: 0,
              percentage: percentage ? parseInt(percentage) : 0,
              quantity:
                movements.find((option) => option.value === movementRefundId)
                  ?.price || 0,
              reason: reason,
            },
          };
        } else if (applyRefund) {
          data = {
            ...data,
            refund: {
              movement_type: movementRefund,
              movement_id: 0,
              percentage: percentageRefund ? parseInt(percentageRefund) : 0,
              quantity:
                movements.find((option) => option.value === movementRefundId)
                  ?.price || 0,
              reason: reasonRefund,
            },
          };
        }
      }

      const response = await supportService.update(support.id, data);
      if (response.status === "success") {
        setTitle({ text: "Support", highlight: "success" });
        setMessage("Status updated successfully");
        setError(false);
        setShowModal(true);
      } else {
        setTitle({ text: "Support", highlight: "error" });
        setMessage(response.message || "Failed to update status");
        setError(true);
        setShowModal(true);
      }
    } catch (error) {
      console.error("Error updating support status:", error);
      setTitle({ text: "Support", highlight: "error" });
      setMessage(error.response.data.message || "Failed to update status");
      setError(true);
      setShowModal(true);
    }
  };

  const handleSelectedStatus = (value) => {
    setSelectedStatus(value.target.value.value);
    setIsCancelled(value.target.value.value === "cancelled");
  };

  const handleSelectedMovementRefund = (value) => {
    console.log("value", value);
    setMovementRefund(value.target.value.value);
    setIsMovementRefund(value.target.value.value === "movement");
  };

  const handleSelectedMovement = (value) => {
    setMovement(value.target.value.value);
    setIsMovement(value.target.value.value === "movement");
  };

  const handleConfirm = () => {
    setShowModal(false);
    if (!error) {
      navigate(-1);
    }
  };

  return (
    <div className="check-support-page">
      <div className="check-support-container">
        <div className="title-container">
          <h1 className="page-title">
            <span className="highlight">
              {isApprovalTicket ? "Subcategory" : "Status"}
            </span>{" "}
            {isApprovalTicket ? "approval" : "change"}
          </h1>
        </div>

        {isApprovalTicket ? (
          <>
            <div className="form-row">
              <div className="form-group">
                <label>Decision*</label>
                <Select
                  options={resultOptions}
                  value={
                    resultOptions.find(
                      (option) => option.value === selectedResult,
                    ) || null
                  }
                  onChange={(option) =>
                    setSelectedResult(option.target.value.value)
                  }
                  isClearable={false}
                  placeholder="Accept or reject"
                  error={errors.result}
                />
              </div>
              <div className="form-group">
                <label>Comments*</label>
                <Input
                  type="text"
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                  placeholder="Enter your comments"
                  error={errors.description}
                />
              </div>
            </div>
          </>
        ) : (
          <>
            <div className="form-row">
              <div className="form-group">
                <label>Status*</label>
                <Select
                  options={statusOptions}
                  value={
                    statusOptions.find(
                      (option) => option.value === selectedStatus,
                    ) || null
                  }
                  onChange={(option) => handleSelectedStatus(option)}
                  isClearable={false}
                  placeholder="Selected options"
                  error={errors.status}
                />
              </div>
              <div className="form-group">
                <label>User response</label>
                <Input
                  type="text"
                  value={description}
                  onChange={(e) => setDescription(e.target.value)}
                  placeholder="Enter description"
                  error={errors.description}
                />
              </div>
            </div>

            <div className="form-row-check">
              <Toggle
                label="Apply refund"
                checked={applyRefund}
                disabled={isCancelled}
                onChange={(checked) => {
                  setApplyRefund(checked);
                  if (checked) setApplyFine(false);
                }}
              />
            </div>

            {applyRefund && (
              <div className="form-row-check-open">
                <div className="form-group-check">
                  <label>Type of movement*</label>
                  <Select
                    options={movementOptions}
                    value={
                      movementOptions.find(
                        (option) => option.value === movementRefund,
                      ) || null
                    }
                    onChange={(e) => {
                      handleSelectedMovementRefund(e);
                    }}
                    isClearable={false}
                    placeholder="Select movement"
                    error={errors.movementRefund}
                  />
                </div>
                {isMovementRefund && (
                  <div className="form-group-check">
                    <label>Movement*</label>
                    <Select
                      options={movements}
                      value={
                        movements.find(
                          (option) => option.value === movementRefundId,
                        ) || null
                      }
                      onChange={(e) => {
                        setMovementRefundId(e.target.value.value);
                      }}
                      isClearable={false}
                      placeholder="Select movement"
                      error={errors.movementRefundId}
                    />
                  </div>
                )}
                <div className="form-group-check">
                  <label>Percentage*</label>
                  <Input
                    type="number"
                    value={percentageRefund}
                    onChange={(e) => setPercentageRefund(e.target.value)}
                    placeholder="Percentage"
                    error={errors.percentageRefund}
                  />
                </div>
                <div className="form-group-check">
                  <label>Reason*</label>
                  <Input
                    type="text"
                    value={reasonRefund}
                    onChange={(e) => setReasonRefund(e.target.value)}
                    placeholder="Reason"
                    error={errors.reasonRefund}
                  />
                </div>
              </div>
            )}

            <div className="form-row-check">
              <Toggle
                label="Apply fine"
                checked={applyFine}
                disabled={isCancelled}
                onChange={(checked) => {
                  setApplyFine(checked);
                  if (checked) setApplyRefund(false);
                }}
              />
            </div>

            {applyFine && (
              <div className="form-row-check-open">
                <div className="form-group-check">
                  <label>Type of movement*</label>
                  <Select
                    options={movementOptions}
                    value={
                      movementOptions.find(
                        (option) => option.value === movement,
                      ) || null
                    }
                    onChange={(e) => handleSelectedMovement(e)}
                    isClearable={false}
                    placeholder="Select movement"
                    error={errors.movement}
                  />
                </div>
                {isMovement && (
                  <div className="form-group-check">
                    <label>Movement*</label>
                    <Select
                      options={movements}
                      value={
                        movements.find(
                          (option) => option.value === movementApplyId,
                        ) || null
                      }
                      onChange={(e) => {
                        setMovementApplyId(e.target.value.value);
                      }}
                      isClearable={false}
                      placeholder="Select movement"
                      error={errors.movementApplyId}
                    />
                  </div>
                )}
                <div className="form-group-check">
                  <label>Percentage*</label>
                  <Input
                    type="number"
                    value={percentage}
                    onChange={(e) => setPercentage(e.target.value)}
                    placeholder="Percentage"
                    error={errors.percentage}
                  />
                </div>
                <div className="form-group-check">
                  <label>Reason*</label>
                  <Input
                    type="text"
                    value={reason}
                    onChange={(e) => setReason(e.target.value)}
                    placeholder="Reason"
                    error={errors.reason}
                  />
                </div>
              </div>
            )}
          </>
        )}

        <div className="form-button-check">
          <Button
            onClick={handleSave}
            children="Save"
            variant="primary"
            fullWidth
            borderRadius={20}
          />
        </div>
        <Modal
          title={title}
          message={message}
          isOpen={showModal}
          onClose={() => setShowModal(false)}
          error={error}
          onConfirm={() => handleConfirm()}
        />
      </div>
    </div>
  );
};

export default CheckSupport;
